import { render, staticRenderFns } from "./EntityEmailView.vue?vue&type=template&id=96713dde&scoped=true"
import script from "./EntityEmailView.vue?vue&type=script&lang=js"
export * from "./EntityEmailView.vue?vue&type=script&lang=js"
import style0 from "./EntityEmailView.vue?vue&type=style&index=0&id=96713dde&prod&lang=scss&scoped=true"
import style1 from "./EntityEmailView.vue?vue&type=style&index=1&id=96713dde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96713dde",
  null
  
)

export default component.exports